/* eslint-disable react/react-in-jsx-scope */
import {useLang} from './Metronici18n'
import {IntlProvider} from 'react-intl'
import '@formatjs/intl-relativetimeformat/polyfill'
import '@formatjs/intl-relativetimeformat/locale-data/en'
import '@formatjs/intl-relativetimeformat/locale-data/tr'

import trMessages from './messages/tr.json'
import enMessages from './messages/en.json'

const allMessages = {
  tr: trMessages,
  en: enMessages,
}

const I18nProvider = ({children}) => {
  const locale = useLang()
  const messages = allMessages[locale]

  return (
    <IntlProvider locale={locale} messages={messages}>
      {children}
    </IntlProvider>
  )
}

export {I18nProvider}
